if (typeof JW === 'undefined') JW = {};
JW.State = (function ()
{
    var _pri = {};
    var publ = {};

    publ.STATE_ERR_FATAL     = -127;
    publ.STATE_ERR_ROOM_JOIN = -31;
    publ.STATE_ERR_ROOM_ADM  = -30;
    publ.STATE_ERR_ROOM      = -29;
    publ.STATE_ERR_CONN      = -28;
    publ.STATE_ERR_SS_META   = -27;
    publ.STATE_ERR_SS_SIZE   = -26;
    publ.STATE_ERR_SS_FROM   = -25;
    publ.STATE_ERR_SS_TO     = -24;
    publ.STATE_ERR_NO_INIT   = -23;
    publ.STATE_ERR_AUTH      = -22;
    publ.STATE_ERR_COOKIE    = -21;
    publ.STATE_ERR_PARAMS    = -20;

    publ.STATE_OTHER         = -8;
    publ.STATE_MAX           = -7;
    publ.STATE_TRY_AGAIN     = -6;
    publ.STATE_INFO          = -5;
    publ.STATE_BUSY          = -4;
    publ.STATE_NOT_FOUND     = -3;
    publ.STATE_REJECT        = -2;
    publ.STATE_ERR           = -1;
    publ.STATE_NONE          = 0;
    publ.STATE_OK            = 1;
    publ.STATE_EXISTING      = 2;

    publ.STATE_READY         = 10;
    publ.STATE_LOADED        = 11;

    return publ;
})();